import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Defense-in-depth client-side gate for admin-only routes (audit H-7).
// The real authorization control is the backend (isSuperAdmin); this just
// prevents non-admins from rendering admin pages and auto-firing admin APIs.
const RequireRole = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const isSuperAdmin = user?.role_id === 1 || user?.roleId === 1;
  return isSuperAdmin ? children : <Navigate to="/dashboard" replace />;
};

export default RequireRole;
